import type { TierIIChemicalCandidate } from '../types/reporting.ts';

/** Coverage is a report destination, never a replacement for threshold assessment. */
export function chemicalReportingCoverage(candidate: TierIIChemicalCandidate) {
  const destinations = new Set(candidate.reportingAllocation?.mixtureProductIDs ?? []);
  const eligible = candidate.exemptionCode
    ? []
    : candidate.products.filter((product) => !product.exemptionCode && product.concentration > 0);
  const covered = eligible.filter((product) => product.reportAsMixture && destinations.has(product.productID));
  const coveredIDs = new Set(covered.map((product) => product.productID));
  const remaining = eligible.filter((product) => !coveredIDs.has(product.productID));
  return { covered, remaining, fullyCovered: covered.length > 0 && remaining.length === 0 };
}

export function chemicalInventoryNeedsReview(candidate: TierIIChemicalCandidate): boolean {
  return (
    candidate.compoundMaxLbs == null ||
    candidate.compoundAvgLbs == null ||
    candidate.products.some(
      (product) =>
        !product.exemptionCode &&
        product.concentration > 0 &&
        (product.maxAmountLbs == null ||
          product.avgAmountLbs == null ||
          product.compoundMaxLbs == null ||
          product.compoundAvgLbs == null),
    )
  );
}

export function chemicalReportingNeedsReview(candidate: TierIIChemicalCandidate): boolean {
  return (
    chemicalInventoryNeedsReview(candidate) ||
    candidate.products.some((product) => !product.exemptionCode && product.ehsQualifier?.status === 'needs_review')
  );
}
